import { COMMON_BASE_URL_PREFIX } from '@flowwai-frontend/shared/constants'

export const SEARCH_RESULTS_LIMIT = 12

export const SEARCH_RESULT_SCROLL_TARGET_ID = 'SEARCH_RESULTS_SCROLL'

export const ImageConstants = {
   noDataViewImageUrl: `${COMMON_BASE_URL_PREFIX}/images/no-results-found.png`
}

export const GS_FIELDS_SKELETON_LOADERS_COUNT = 6
